import { WorkflowLogFilter } from '@workflows/types';

type WorkflowLogFilterOption = {
  value: WorkflowLogFilter;
  label: string;
};

export const WORKFLOW_LOG_FILTER_OPTIONS: readonly WorkflowLogFilterOption[] = [
  { value: null, label: 'Все' },
  { value: 'errors', label: 'Ошибки' },
  { value: 'files', label: 'Файлы' },
  { value: 'forms', label: 'Формы' },
  { value: 'system', label: 'Система' },
];
